export default "__VITE_ASSET__CYs06gxW__"